import React from 'react';
import ContourImages from './ContourImages';
import Subtitles from './Subtitles';
import { IconCheckCircle } from '../icons/icons';
import { Link } from 'react-router-dom';
import '../gral-stylesheets/template.scss';



class Template extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      animation: this.props.animation
    }
  }

  componentDidMount() {
    this.setState({ animation: this.props.animation });
  }

  render() {
    let xDirectionNormal = this.props.xDirectionNormal;
    let templateType = this.props.templateType;

    return (
      <div className='template-container'>
        <div className={
          xDirectionNormal
            ? 'template-content'
            : 'template-content-reverse'
        }>
          <div
            className='image-container'
          >
            {
              !this.props.templateType ?
                <ContourImages
                  image={this.props.image}
                />
                : ''
            }
          </div>
          <div className= 'template-text'>
            <Subtitles
              darkText={this.props.darkText}
              titleSmall={this.props.titleSmall}
              titleBig={this.props.titleBig}
            />
            <ul className='template-text-list'>
              {
                this.props.description.map((obj, index) =>
                  <li
                    key={index}
                    className={this.props.darkText ? 'text-dark' : 'text-clear'}
                  >
                    <div className={this.props.darkText ? 'text-dark-subtitle' : 'text-clear-subtitle'}>
                      <i><IconCheckCircle /></i>
                      <h3>
                        {
                          templateType === 'about-us' ?
                            obj.subTitle
                            : `${obj.subTitle}:`
                        }
                      </h3>
                    </div>
                    <p>{obj.text}</p>
                  </li>
                )}
            </ul>
            <div className='button-join-container'>
              {
                templateType === 'about-us' ?
                  <Link to='/about-us'>
                    <h3>More</h3>
                  </Link>
                  :
                  <button
                    className='button-join'
                    onClick={this.props.joinOpenHandle}
                  >
                    <h3>{this.props.textButton}</h3>
                  </button>
              }
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Template;